module.exports = __webpack_public_path__ + "static/media/modern-slavery.927dfe8f.jpg";